import React, { useState } from "react";
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import DropdownFilter from "../../components/common/DropdownFilter";
import NormalSearch from "../../components/common/NormalSearch";
import ListView from "../../components/common/ListView";
import CommonModal from "../../components/common/CommonModal"; 
import AddWeightRangeModal from "./_components/AddWeightRangeModal";
import EditViewWeightModal from "./_components/EditViewWeightModal";

const driverData = [
  {
    id: 1,
    fromKg: "5",
    toKg: "120",
    creator: "Admin",
    createDate: "4 Aug 2025",
    for: "Client",
    active: false,
  },
  {
    id: 2,
    fromKg: "5",
    toKg: "120",
    creator: "Admin",
    createDate: "4 Aug 2025",
    for: "Client",
    active: true,
  },
  {
    id: 3,
    fromKg: "5",
    toKg: "120",
    creator: "Admin",
    createDate: "4 Aug 2025",
    for: "Client",
    active: false,
  },
  {
    id: 4,
    fromKg: "5",
    toKg: "120",
    creator: "Admin",
    createDate: "4 Aug 2025",
    for: "Client",
    active: true,
  },
  {
    id: 5,
    fromKg: "5",
    toKg: "120",
    creator: "Admin",
    createDate: "4 Aug 2025",
    for: "Client",
    active: true,
  },
];

const WeightManagement: React.FC = () => {
  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const openShelveToggleModal = () => {
    setOpenShelve(!openShelve);
  };
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return (
    <>
      <div className="p-4 space-y-4">
        <div className="bg-[#F7F6F2] rounded-3xl">
          <div className="flex justify-between items-center w-full  p-4">
            <div className="flex justify-between items-center  rounded-tl-3xl rounded-tr-3xl">
              <h1 className="text-3xl text-[#212121]">Weight Management</h1>
            </div>
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <div className="flex items-center gap-2">
                <ColumnsFilter columnsData={[]} />
                <DropdownFilter filterheadings={[]} />
                <NormalSearch />
              </div>
              <button className="p-2 text-sm rounded-full border border-[#D8D8D8] bg-white">
                <IconDownload stroke={1.5}  size={20}/>
              </button>
              <button
                onClick={openShelveToggleModal}
                className="flex items-center gap-1  p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
              >
                <IconPlus stroke={1.5} size={20}/>
              </button>
            </div>
          </div>
          <div>
            {" "}
            <ListView
              data={driverData}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={[
                { label: "#", render: (_, i) => i + 1 },
                {
                  label: "From (kg)",
                  render: (c) => c.fromKg,
                },
                {
                  label: "To (kg)",
                  render: (c) => c.toKg,
                },
                { label: "Creator", render: (c) => c.creator },
                {
                  label: "Create Date",
                  render: (c) => c.createDate,
                },
                { label: "For", render: (c) => c.for },
                {
                  label: "Actions",
                  render: () => (
                    <button
                      onClick={openModal}
                      className="p-2 border rounded-full bg-[#F7F6F2]"
                    >
                      <IconEye />
                    </button>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>

      <CommonModal
        title={"Add Weight Range"}
        open={openShelve}
        closeButtonText={"Cancel"}
        onClose={openShelveToggleModal}
        actionButtonText="Save"
        actionButtonOnClick={openShelveToggleModal}
      >
        <AddWeightRangeModal />
      </CommonModal>
      <EditViewWeightModal open={isOpen} onClose={closeModal} />
    </>
  );
};

export default WeightManagement;
